import isNil from 'lodash/isNil';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setMeasureAxisMaxValue,
  setMeasureAxisMinValue,
  setMeasureAxisScale,
} from 'common/authoring_workflow/actions';
import {
  getMeasureAxisMaxValue,
  getMeasureAxisMinValue,
  getMeasureAxisScale,
  isOneHundredPercentStacked,
  isTimelineChart,
} from 'common/authoring_workflow/selectors/vifAuthoring';
import { AxisScaleSelector } from './AxisScaleSelector';
import {
  MEASURE_AXIS_SCALE_CUSTOM,
  MEASURE_AXIS_SCALE_MIN_TO_MAX,
  MEASURE_AXIS_SCALE_ZERO_TO_MAX,
} from 'common/authoring_workflow/constants';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';

const getAxisScale = (vifAuthoring: object): string => {
  const maxValue = getMeasureAxisMaxValue(vifAuthoring);
  const minValue = getMeasureAxisMinValue(vifAuthoring);
  if (!isNil(maxValue) || !isNil(minValue)) {
    return MEASURE_AXIS_SCALE_CUSTOM;
  } else if (getMeasureAxisScale(vifAuthoring) === MEASURE_AXIS_SCALE_MIN_TO_MAX) {
    return MEASURE_AXIS_SCALE_MIN_TO_MAX;
  } else {
    return MEASURE_AXIS_SCALE_ZERO_TO_MAX;
  }
};

export const AxisScaleSelectorSingle = () => {
  const vifAuthoring = useSelector((state: AuthoringWorkflowState) => state.vifAuthoring);
  const [axisScale, setAxisScale] = useState(getAxisScale(vifAuthoring));
  const dispatch = useDispatch();

  useEffect(() => {
    if (axisScale === MEASURE_AXIS_SCALE_MIN_TO_MAX) {
      setAxisScale(getAxisScale(vifAuthoring));
    }
  }, [vifAuthoring, axisScale]);

  const onMaxValueTextboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setMeasureAxisMaxValue(event.target.value));
    dispatch(setMeasureAxisScale());
  };

  const onMinValueTextboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setMeasureAxisMinValue(event.target.value));
    dispatch(setMeasureAxisScale());
  };

  const onRadioButtonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const axisScaleValue = event.target.value;
    setAxisScale(axisScaleValue);
    switch (axisScaleValue) {
      case MEASURE_AXIS_SCALE_ZERO_TO_MAX:
        dispatch(setMeasureAxisScale());
        dispatch(setMeasureAxisMaxValue());
        dispatch(setMeasureAxisMinValue());
        break;
      case MEASURE_AXIS_SCALE_MIN_TO_MAX:
        dispatch(setMeasureAxisScale(MEASURE_AXIS_SCALE_MIN_TO_MAX));
        dispatch(setMeasureAxisMaxValue());
        dispatch(setMeasureAxisMinValue());
        break;
    }
  };

  return (
    <AxisScaleSelector
      axisScale={axisScale}
      disabled={isOneHundredPercentStacked(vifAuthoring)}
      disableScaleMinToMaxValue={!isTimelineChart(vifAuthoring)}
      key={0}
      maxLimit={getMeasureAxisMaxValue(vifAuthoring) || ''}
      minLimit={getMeasureAxisMinValue(vifAuthoring) || ''}
      onMaxValueTextboxChange={onMaxValueTextboxChange}
      onMinValueTextboxChange={onMinValueTextboxChange}
      onRadioButtonChange={onRadioButtonChange}
    />
  );
};
